import { render, staticRenderFns } from "./MassFailedBuilds.vue?vue&type=template&id=b41bd8d8&"
import script from "./MassFailedBuilds.vue?vue&type=script&lang=js&"
export * from "./MassFailedBuilds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports